
import { defineComponent, computed } from "vue";
import { useStore } from "@/store";

export default defineComponent({
  name: "layout-loader",
  props: {
    logo: String,
  },
  setup() {
    const store = useStore();

    const loaderType = computed(() => {
      return store.getters.layoutConfig("loader.type");
    });

    return {
      loaderType,
    };
  },
});
